import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import PegasusLogo from "@/components/PegasusMark";

const nav = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#0A0A0A]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center group"
          data-testid="header-logo"
        >
          <PegasusLogo className="h-11 md:h-12 transition-transform duration-500 group-hover:-translate-y-0.5" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors duration-300"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
          <a
            href="#contact"
            className="text-sm text-black bg-[#D4AF37] hover:bg-[#E5C665] px-5 py-2.5 transition-colors"
            data-testid="nav-cta-enquire"
          >
            Enquire
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden border-t border-white/5 bg-[#0A0A0A]"
          data-testid="mobile-nav"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {nav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-base text-[#E5E5E5] hover:text-[#D4AF37]"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="text-center text-black bg-[#D4AF37] px-5 py-3"
              data-testid="mobile-nav-cta"
            >
              Enquire
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
